import type { Branded } from './brand';
import { createBranded } from './brand';

export type IngredientId = Branded<string, 'IngredientId'>;
export function createIngredientId(value: string): IngredientId {
  return createBranded(value);
}
